import { Set } from 'immutable';

export function isArrayOf(t, o: any): boolean {
    return Array.isArray(o) && o.length > 0 && o[0] instanceof t;
}

export function isEmptyArray(o: any): boolean {
    return o && o.constructor === Array && o.length === 0;
}

export function except<T>(items: T[], ...excludedItems: T[]): T[] {
    const se = Set(excludedItems);
    return items.filter(x => !se.has(x));
}

export function move<T>(items: T[], from: number, to: number): T[] {
    const clone = items.slice();
    clone.splice(to, 0, clone.splice(from, 1)[0]);
    return clone;
}

export function maxDefaultZero(x: number[]): number {
    if (x.length === 0)
        return 0;

    let max = x[0];
    for (let i = 1; i < x.length; i++) {
        if (x[i] > max)
            max = x[i];
    }

    return max;
}

export function sum(items: number[]): number {
    return items.reduce((a, x) => a + x, 0);
}

export function sequenceEqual<T>(a: T[], b: T[]): boolean {
    return a.length === b.length && a.every((x, i) => x === b[i]);
}

export function zip<T1, T2, T3>(a: T1[], b: T2[], projection: (x: T1, y: T2) => T3) {
    return a.slice(0, Math.min(a.length, b.length)).map((x, i) => projection(x, b[i]));
}

export function xor<T>(a: T[], b: T[]): T[] {
    const sa = Set(a);
    const sb = Set(b);
    const excluded = sa.intersect(sb);
    return sa.union(sb).subtract(excluded).valueSeq().toArray();
}

export function replace<T>(items: T[], o: T, n: T) {
    return items.map(x => x === o ? n : x);
}

export function partition<T>(input: T[], discriminator: (x: T) => boolean): [T[], T[]] {
    const a = [];
    const b = [];
    input.forEach(x => {
        if (discriminator(x))
            a.push(x)
        else
            b.push(x);
    });

    return [a, b];
}

export function pairwise<T>(input: T[]) {
    return zip(input, input.slice(1), (x, y) => [x, y]);
}